import Metamask from "./icons/Metamask";
import WalletConnect from "./icons/WalletConnect";
import {FC} from "react";
import {SvgProps} from "@pancakeswap/uikit/dist/components/Svg/types";
import {arbitrum, base, fantom, fantomTestnet, optimism, polygonZkEvm} from "wagmi/chains";
import {shimmerEvm} from "~/utils/wallets/customChains/shimmerEVM";

export const CHAINS = [arbitrum, base, fantom, fantomTestnet, optimism, polygonZkEvm, shimmerEvm]

export enum ConnectionType {
  // INJECTED = 'INJECTED',
  // GNOSIS_SAFE = 'GNOSIS_SAFE',
  METAMASK = 'METAMASK',
  WALLET_CONNECT = 'WALLET_CONNECT',
}

export interface Config {
  title: string;
  icon: FC<SvgProps>;
  connectionType: ConnectionType;
  priority: number;
}

const connectors: Config[] = [
  {
    title: "Metamask",
    icon: Metamask,
    connectionType: ConnectionType.METAMASK,
    priority: 1,
  },
  {
    title: "Wallet Connect",
    icon: WalletConnect,
    connectionType: ConnectionType.WALLET_CONNECT,
    priority: 2,
  },
  // {
  //   title: "Injected",
  //   icon: Metamask,
  //   connectionType: ConnectionType.INJECTED,
  //   priority: 3,
  // },
  // {
  //   title: "Gnosis Safe",
  //   icon: Metamask,
  //   connectionType: ConnectionType.GNOSIS_SAFE,
  //   priority: 4,
  // },
];

export default connectors;
export const connectorLocalStorageKey = "connectorIdv2";
export const walletLocalStorageKey = "wallet";
